import script from "./Renko.vue?vue&type=script&lang=js"
export * from "./Renko.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__